const ErrorPage = () => {
  return (
    <div style={{ height: '90%' }}>
      <h1>ERROR!</h1>
    </div>
  );
};

export default ErrorPage;
